import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { ICompanySuppliers } from '../Interfaces/ICompanySuppliers';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';

@Injectable({
	providedIn: 'root',
})

export class CompanySuppliersService extends RestCallService {

	public dataToSend: ICompanySuppliers = {
		pkcompanysupplier: 0,
		companysupplier: '',
        address: '',
		city: '',
		state: '',
		postal_code: '',
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 1,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 1,
		available: true,
        fksite: 0,
		employeecreatorname: '',
		employeeupdatername: '',
		username: '',
        fkemployee: 0,
        check: true,
		site: '',
	};

	constructor(
		public httpClient: HttpClient,
		private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient, 'JACSapi', toastr, notificationService, translate);
	}

	public GetList() {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
		return this.post<ICompanySuppliers[]>('/api/CompanySuppliers/GetCompanySuppliers', this.dataToSend);
  }
  
  public GetAvailableCompanySuppliers() {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
		return this.post<ICompanySuppliers[]>('/api/CompanySuppliers/GetAvailableCompanySuppliers', this.dataToSend);
	}

	public AddCompanySupplier(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
				this.cognitoService.LogOut();
		this.dataToSend.companysupplier = data.txtcompanysupplier.trim();
        this.dataToSend.address = data.txtaddress.trim();
		this.dataToSend.city = data.txtcity.trim();
		this.dataToSend.state = data.txtstate.trim();
		this.dataToSend.postal_code = data.txtpostalcode.trim();
		this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
		return this.post('/api/CompanySuppliers/CreateCompanySupplier', this.dataToSend);
	}

	public EditCompanySupplier(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
				this.cognitoService.LogOut();
		this.dataToSend.pkcompanysupplier = data.pkcompanysupplier;
		this.dataToSend.companysupplier = data.txtcompanysupplier.trim();
        this.dataToSend.address = data.txtaddress.trim();
		this.dataToSend.city = data.txtcity.trim();
		this.dataToSend.state = data.txtstate.trim();
		this.dataToSend.postal_code = data.txtpostalcode.trim();
		return this.put('/api/CompanySuppliers/UpdateCompanySupplier', this.dataToSend);
	}

	public ChangeStatus(data: any) {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		this.dataToSend.pkcompanysupplier = data.pkcompanysupplier;
		this.dataToSend.available = data.available;
		return this.put('/api/CompanySuppliers/ChangeStatus', this.dataToSend);
	}
}
